
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/product/[pid]",
      function () {
        return require("private-next-pages/[domain]/product/[pid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/product/[pid]"])
      });
    }
  